import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/core/http-services/auth.service';
import { AzureAccountsService } from 'src/app/core/http-services/azure-accounts.service';
import { EditAzureAccountComponent } from 'src/app/modules/edit-azure-account/edit-azure-account.component';
import { ConfirmationDialogService } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.service';
import { PAGE_RESULT_SIZE } from 'src/app/shared/constants';
import { AzureAccountDisplay } from 'src/app/shared/models/azure-accounts.model';
import { Pagination } from 'src/app/shared/models/pagination.model';
import { SpecialRoles } from 'src/app/shared/models/signin.model';
import { GeneralFunctions } from '../../shared/general-functions';

@Component({
  selector: 'app-manage-azure-accounts',
  templateUrl: './manage-azure-accounts.component.html',
  styleUrls: ['./manage-azure-accounts.component.css']
})
export class ManageAzureAccountsComponent implements OnInit {
  pageNo: number = 0;
  pager: Pagination = new Pagination();
  accounts: AzureAccountDisplay[] = new Array();
  totalRecords: number = 0;
  successMessage: string = '';
  errorMessage: string = '';
  isShowSuccess: boolean = false;
  isShowError: boolean = false;
  roles: SpecialRoles;
  filterId: number = 0;
  filterInput: string = '';
  isFilterEntered: boolean = true;
  actualFilterInput: string = '';

  constructor(private azureAccountsService: AzureAccountsService,
    private modalService: NgbModal,
    private generalFunctions: GeneralFunctions,
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService) { }

  ngOnInit(): void {
    // Note: Below 'queryParams' can be replaced with 'params' depending on your requirements
    this.activatedRoute.queryParams.subscribe(params => {
      const id = params['id'];
      if (id) {
        this.filterId = id;
      }

    });

    this.roles = this.authService.getSpecialRoles();
    this.getNextAccountsBatch(true);
  }

  doFilter() {
    this.actualFilterInput = '';

    if (!this.filterInput) {
      this.isFilterEntered = false;
      return
    }
    else
      this.isFilterEntered = true;

    this.pageNo = 0;
    this.actualFilterInput = this.filterInput;
    this.getNextAccountsBatch(true);
  }

  getNextAccountsBatch(isForwardMove: boolean = true) {
    if (isForwardMove) {
      this.pageNo++;
    }
    else {
      this.pageNo--;
      if (this.pageNo == 0) {
        this.pageNo = 1;
      }
    }
    if (this.filterId === 0) {
      this.azureAccountsService.getRecordCounts(this.actualFilterInput)
        .subscribe((data: number) => {
          this.totalRecords = data;
          this.pager = this.generalFunctions.paginate(this.totalRecords, this.pageNo, PAGE_RESULT_SIZE, 5);
          if (data > 0) {
            this.azureAccountsService.getAccounts(this.pageNo, 10, this.actualFilterInput)
              .subscribe((dataList: AzureAccountDisplay[]) => {
                if (dataList && dataList.length > 0) {
                  this.accounts = dataList;
                }
              });
          }
        });
    }
    else {
      this.azureAccountsService.getAccountById(this.filterId)
        .subscribe((data: AzureAccountDisplay) => {
          if (data) {
            this.accounts = new Array();
            this.accounts.push(data);
          }
        });
    }
  }

  logout() {

  }

  removeFilter() {
    if (this.filterId > 0) {
      this.filterId = 0;
      this.router.navigate(['/azureaccounts']);
      this.getNextAccountsBatch(false);
    }
    else {
      this.pageNo = 0;
      this.actualFilterInput = '';
      this.filterInput = '';
      this.isFilterEntered = true;
      this.getNextAccountsBatch(true);
    }

  }

  openModal(id: number = 0) {
    const modalRef = this.modalService.open(EditAzureAccountComponent, { windowClass: 'modal-holder', centered: true });
    modalRef.componentInstance.azureAccountId = id;
    if (id > 0) {
      var curAccount = this.accounts.find(a => a.Id === id);
      if (curAccount) {
        modalRef.componentInstance.currentAccount = curAccount;
        modalRef.componentInstance.setFormValues();
      }
    }

    /*
    * | FOLLOWING WILL EMIT TO SUGGEST
    * | ACCOUNT IS CREATED OR UPDATED SUCCESSFULLY
    */
    modalRef.componentInstance.isAccountSaved.subscribe((value) => {
      this.isShowSuccess = true;
      this.successMessage = "Azure account saved/update successfully";
      this.refreshRecords();
    });

  }

  closeSuccess() {
    this.isShowSuccess = false;
  }

  closeError() {
    this.isShowError = false;
  }

  refreshRecords() {
    if (this.pageNo == 0) {
      this.pageNo = 1;
    }

    this.azureAccountsService.getRecordCounts()
      .subscribe((data: number) => {
        this.totalRecords = data;
        this.pager = this.generalFunctions.paginate(this.totalRecords, this.pageNo, PAGE_RESULT_SIZE, 5);


        if (data > 0) {
          this.azureAccountsService.getAccounts(this.pageNo)
            .subscribe((dataList: AzureAccountDisplay[]) => {
              if (dataList && dataList.length > 0) {
                this.accounts = dataList;
              }
            });
        }
      });
  }

  fetchSpecificPage(pgNo: number) {
    if (pgNo == this.pageNo) {
      return;
    }

    this.pageNo = pgNo;
    this.refreshRecords();
  }

  deleteAccount(id: number) {
    this.confirmationDialogService.confirm('Please confirm', 'Are you sure you want to delete this Azure account?')
      .then((confirmed) => {
        if (confirmed) {

          this.azureAccountsService.deleteAccount(id)
            .subscribe((data: boolean) => {
              if (data) {
                this.isShowSuccess = true;
                this.successMessage = "Account deleted successfully";
                this.refreshRecords();
              }
              else {
                this.isShowError = true;
                this.errorMessage = "Something went wrong";
              }
            },
              error => {
                this.isShowError = true;
                this.errorMessage = `Could not delete, server returned error: ${error}`;
              })
        }
        else {
          return;
        }
      }).catch((error) => {
        return;
      });
  }
}
